<template>
  <div class="tab-bd">
    <div class="ub tab">
      <div @click="onEmit(item)" class="ub-f1 tab-item" :class="{'cur': currentIndex === index}" v-for="(item,index) in list">{{item.name}}
      </div>
      <div class="tab-bar" :style="barStyle">
        <span :style="{ width:barWidth }"></span>
      </div>
    </div>
  </div>
</template>
<script>
/**
   * @param list [Array] tab栏目数组(包含name,key属性)
   * @param value [Boolean] v-model绑定的值为对象(包含name,key属性)
   * @param barWidth [String] 滑动条宽度，默认自适应
   * @param change [Function] 点击变更触发事件,参数为选中对象
   *
   * @example
   *
    <t-tab :list="[]" v-model="" @change=""></t-tab>
   */
export default {
  name: 'tTab',
  data() {
    return {
      direction: 'forward',
    };
  },
  props: {
    // 数组需包含key,name属性
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    // 选中值
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    // bar宽度
    barWidth: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    currentIndex() {
      return this.list.map(t => t.key).indexOf(this.value.key);
    },
    barLeft() {
      return `${this.currentIndex * (100 / this.list.length)}%`;
    },
    barRight() {
      return `${(this.list.length - this.currentIndex - 1) * (100 / this.list.length)}%`;
    },
    barStyle() {
      return {
        left: this.barLeft,
        right: this.barRight,
      };
    },
  },
  methods: {
    onEmit: function (item) {
      this.$emit('input', item);
      this.$emit('change', item);
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";

.tab-bd {
  .tab {
    height: 44px;
    background-color: #fff;
    position: relative;
    @include border-1px-b(#e5e5e5);
    .tab-item {
      font-size: 14px;
      text-align: center;
      line-height: 44px;
      color: #666;
      &.cur {
        color: #FF9900;
      }
    }
    .tab-bar {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      z-index: 1;
      text-align: center;
      -webkit-transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s;
      transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s;
      span {
        display: block;
        background-color: #FF9900;
        margin: auto;
        height: 100%;
        width: 100%;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tab.vue